import { api, ApiError } from './client.ts';
import type { components } from './schema.gen.ts';
import { meetsStaleView, messageOf } from './serverFailure.ts';

export type Song = components['schemas']['Song'];

const toldByThePausedModal = 'inactive-device';

export const chooseSong = async (song: Song): Promise<void> => {
  const { error, response } = await api.POST('/game/choose-song', { body: { id: song.id } });
  if (error && !meetsStaleView(error.slug) && error.slug !== toldByThePausedModal)
    throw new ApiError(response.status, messageOf('chooseSong', error), error.slug);
};

export const guessSong = async (song: Song): Promise<void> => {
  const { error, response } = await api.POST('/game/guess-song', { body: { id: song.id } });
  if (error && !meetsStaleView(error.slug)) {
    throw new ApiError(response.status, messageOf('guessSong', error), error.slug);
  }
};
